import { TColorScheme } from "../colors.types";

// Source: https://github.com/apache/echarts/blob/master/theme/dark.js
export const getLightEchartsTheme = (colors: TColorScheme) => {
  return {
    title: {
      textStyle: {
        fontSize: 16,
        fontWeight: 500,
        color: colors.neutral[1000],
      },
    },
    legend: {
      textStyle: {
        color: colors.neutral[700],
        fontSize: 13,
        fontWeight: 500,
        lineHeight: 14,
      },
    },
    valueAxis: {
      axisLabel: {
        color: colors.neutral[500],
      },
      splitLine: {
        lineStyle: {
          color: colors.neutral[300],
        },
      },
    },
    categoryAxis: {
      axisLabel: {
        color: colors.neutral[500],
      },
    },
  };
};
